import { SEND_EMAIL } from '../../constants/endpoints';

// There is a "sendLabelEmail" lib function, but it uses the old API where we are sending
// all the information through query parameters even though it's a POST request. That endpoint
// will eventually be deprecated in favor of this.

// TODO: Derive all arguments from state instead of passing them
export default (browserFingerprint) =>
  async ({ retailerName, encryptedReturnId, locale, email }) => {
    try {
      const response = await fetch(SEND_EMAIL(retailerName), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'narvar-tfid': browserFingerprint,
        },
        body: JSON.stringify({
          locale,
          return_id: encryptedReturnId,
          email_address: email,
        }),
      });

      const { status: { status, message: statusMessage } = {} } = await response.json();
      const code = statusMessage && statusMessage.code;
      const message = statusMessage && statusMessage.message;

      if (status === 'SUCCESS') return true;

      throw new Error(`Status ${code}: ${message}`);
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }

    return false;
  };
